import { Component, OnInit, OnDestroy } from '@angular/core';
import { VantageShellService } from 'src/app/services/vantage-shell/vantage-shell.service';
import { SettingsService } from 'src/app/services/settings.service';
import { DeviceService } from 'src/app/services/device/device.service';
import { TimerService } from 'src/app/services/timer/timer.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-page-settings',
	templateUrl: './page-settings.component.html',
	styleUrls: ['./page-settings.component.scss'],
	providers: [TimerService]
})
export class PageSettingsComponent implements OnInit, OnDestroy {

	backId = 'setting-page-btn-back';

	toggleActionTriggered = false;
	isMessageSettings = false;

	valueToBoolean = [false, true, false];

	preferenceSettings: any;

	messageSettings = [
		{
			leftImageSource: ['fal', 'browser'],
		},
		{
			leftImageSource: ['fal', 'gift'],
		},
		{
			leftImageSource: ['fal', 'comment-alt-dots'],
		}
	];

	otherSettings = [
		{
			leftImageSource: ['fal', 'shoe-prints'],
		},
		{
			leftImageSource: ['fal', 'shoe-prints'],
		}
	];

	betaSettings = [
		{
			leftImageSource: ['fal', 'flask'],
		}
	];

	constructor(
		private shellService: VantageShellService,
		private settingsService: SettingsService,
		public deviceService: DeviceService,
		private timerService: TimerService,
		private loggerService: LoggerService
	) {
		this.preferenceSettings = this.shellService.getPreferenceSettings();
	}

	ngOnInit() {
		this.getAllToggles();
		this.timerService.start();
	}

	ngOnDestroy() {	}

	getAllToggles() {
		if (this.settingsService.isMessageSettings) {
			this.toggleActionTriggered = this.settingsService.toggleActionTriggered;
			this.isMessageSettings = true;
		} else {
			this.getPreferenceSettingsValue();
		}
	}

	getPreferenceSettingsValue() {
		if (this.preferenceSettings) {
			try {
				this.preferenceSettings.getMessagingPreference('en').then((messageSettings: any) => {
					if (messageSettings) {
						this.toggleActionTriggered = this.getMassageStettingValue(messageSettings, 'ActionTriggered');
						this.isMessageSettings = true;
					}
				}).catch((error) => {
					this.loggerService.exception('preferenceSettings.getMessagingPreference error', error);
                    this.isMessageSettings = false;
                });
			} catch (error) {
				this.loggerService.exception('PageSettingsComponent.getPreferenceSettingsValue exception', error);
			}
		}
	}

	getMassageStettingValue(messageSettings: Array<any>, id: string) {
		return this.valueToBoolean[messageSettings.find(mss => mss.id === id).settingValue];
	}

	onToggleOfActionTriggered(event: any) {
		this.toggleActionTriggered = event.switchValue;
		this.settingsService.toggleActionTriggered = event.switchValue;
		if (this.preferenceSettings) {
			const categoryList = [{
				id: 'ActionTriggered',
				settingValue: event.switchValue ? 1 : 2,
			}];
			this.preferenceSettings.setMessagingPreference(categoryList).then((result: any) => {
				if (!result || result.Result !== 'Success') {
					this.toggleActionTriggered = !event.switchValue;
					this.settingsService.toggleActionTriggered = !event.switchValue;
				}
			}).catch(() => { });
		}
	}

	onKeyPress($event) {
		if ($event.keyCode === 13) {
			$event.target.click();
		}
	}
}
